// test472
(472 && 0);
